import React from "react";
import { GridColumnMenuCheckboxFilter, GridColumnMenuFilter, GridColumnMenuSort} from "@progress/kendo-react-grid";

export const ColumnMenu = (props) => {
  return (
    <div>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuFilter {...props} expanded={true}/>
    </div>
  );
};


export const ColumnMenuCheckboxFilter = (props) => {
  return (
    <div>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuCheckboxFilter {...props} expanded={true}/>
    </div>
  );
};
